import { useRouter } from 'next/router';

import { routeList } from '@routes/routeList';
import { MainLayout } from '@com/Layout';
import BasketItems from '@com/shared/basket-items';
import Categories from './components/Categories';
import Products from './components/Products';

type ProductsListContainerProps = {
  categoryName?: string;
  categoryCodeLevel1?: string;
};

const ProductsListContainer = ({
  categoryName,
  categoryCodeLevel1,
}: ProductsListContainerProps) => {
  const { push } = useRouter();

  return (
    <MainLayout
      hasHeader
      headerType="withoutLogo"
      title={categoryName || 'داروی بدون نسخه'}
      backIconHandler={() => push(routeList.otcMedicine)}
      hasBackButton
      hasBasketIcon
      scrollToTop
    >
      <Categories activeCategoryCode={categoryCodeLevel1} />
      <Products categoryCodeLevel1={categoryCodeLevel1} />
      <BasketItems />
    </MainLayout>
  );
};

export default ProductsListContainer;
